import React from 'react';
import TicketDetailsForm from './components/ticketDetailsForm/TicketDetailsForm';
import SaleDetailsForm from './components/saleDetailsForm/SaleDetailsForm';
import {eProductSubCategoryType, eProductCategoryType} from 'data/enums/products';
import {AdFlightTopDetails} from 'gui/pages/mainRouter/pages/ad/components/adFlight';
import PreparedEditor from 'gui/components/editors/commons/preparedEditor';


const FlightEditor = (props) => (
  <PreparedEditor {...props}
                  detailsEditorComponent={TicketDetailsForm}
                  saleEditorComponent={SaleDetailsForm}
                  topDetailsComponent={AdFlightTopDetails}

  />
);

FlightEditor.defaultProps = {
  product: {ticketDetails: {}, saleDetails: {}},
  steps: [
    'פרטי טיסה',
    'קביעת מחיר',
    'אישור מודעה',
  ],
  isAdmin: false,
  onSubmit: () => {
  },
  productType: eProductCategoryType.TOURISM,
  productSubType: eProductSubCategoryType.FLIGHT,
}

export default FlightEditor;
